import { render, staticRenderFns } from "./full.vue?vue&type=template&id=da1ed530&scoped=true&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"
import style0 from "./full.vue?vue&type=style&index=0&id=da1ed530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1ed530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VImg,VMain})
